<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4 weight600" title="사용조건">

          <AvailableStore></AvailableStore>

          <b-form-group label-cols="2" horizontal label="판매기간" class="mt-4">
            <b-row align-v="center" class="justify-content-start" no-gutters>
              <b-col md="auto">
                <b-form-radio-group v-model="_hasSalesPeriod">
                  <b-form-radio :value="false">제한없음</b-form-radio>
                  <b-form-radio :value="true">판매기간 지정</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>

            <b-row align-v="center" class="justify-content-start" no-gutters :hidden="!_hasSalesPeriod">
              <b-col md="auto" class="mt-3">
                <b-row align-v="center" no-gutters>
                  <b-col md="auto">
                    <div class="form-group has-float-label">
                      <v-date-picker
                        mode="single"
                        v-model="_saleStartDate"
                        :input-props="{ class:'form-control', placeholder: $t('date.start-date') }"></v-date-picker>
                      <span>{{ $t('date.start-date') }}</span>
                    </div>
                  </b-col>
                  <b-col md="auto" class="ml-2">
                    <span>~</span>
                  </b-col>
                  <b-col md="auto" class="ml-2">
                    <div class="form-group has-float-label">
                      <v-date-picker
                        mode="single"
                        v-model="_saleEndDate"
                        :input-props="{ class:'form-control', placeholder: $t('date.end-date') }"></v-date-picker>
                      <span>{{ $t('date.end-date') }}</span>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

          </b-form-group>

          <b-form-group label-cols="2" horizontal label="유효기간" class="mt-4" v-if="goodsType !='Booking'">
            <b-row align-v="center" class="justify-content-start" no-gutters>
              <b-col md="auto">
                <b-form-radio-group v-model="_expirationDateSetting">
                  <b-form-radio value="SetDayCount">날짜수 입력</b-form-radio>
                  <b-form-radio value="SetFromToDate">기간 지정</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
            <b-row align-v="center" class="justify-content-start mt-3" no-gutters
                   :hidden="_expirationDateSetting !== 'SetDayCount'">
              <b-col md="auto">
                <span>구매 후</span>
              </b-col>
              <b-col cols="1" class="ml-2">
                <b-input-group size="sm">
                  <b-input min="0" type="number" v-model="_validDayCount"></b-input>
                </b-input-group>
              </b-col>
              <b-col md="auto" class="ml-2">
                <span>일</span>
              </b-col>
            </b-row>

            <b-row align-v="center" class="justify-content-start" no-gutters
                   :hidden="_expirationDateSetting === 'SetDayCount'">
              <b-col md="auto" class="mt-3">
                <b-row align-v="center" no-gutters>
                  <b-col md="auto">
                    <div class="form-group has-float-label">
                      <v-date-picker
                        mode="single"
                        v-model="_validFromDate"
                        :input-props="{ class:'form-control', placeholder: $t('date.start-date') }"></v-date-picker>
                      <span>{{ $t('date.start-date') }}</span>
                    </div>
                  </b-col>
                  <b-col md="auto" class="ml-2">
                    <span>~</span>
                  </b-col>
                  <b-col md="auto" class="ml-2">
                    <div class="form-group has-float-label">
                      <v-date-picker
                        mode="single"
                        v-model="_validToDate"
                        :input-props="{ class:'form-control', placeholder: $t('date.end-date') }"></v-date-picker>
                      <span>{{ $t('date.end-date') }}</span>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group label-cols="2" horizontal label="취소기한" class="mt-4" v-if="goodsType !='Booking'">
            <b-row align-v="center" class="justify-content-start" no-gutters>
              <b-col md="auto">
                <b-form-radio-group v-model="_cancellableTimeSetting">
                  <b-form-radio value="ForDayCountAfterPurchase0">취소불가</b-form-radio>
                  <b-form-radio value="ForDayCountAfterPurchase7">7일 취소가능</b-form-radio>
                  <b-form-radio value="ForDayCountAfterPurchase90">90일 취소가능</b-form-radio>
                  <b-form-radio value="ForDayCountAfterPurchase">직접입력</b-form-radio>
                </b-form-radio-group>
              </b-col>
              <b-col cols="1" class="ml-2" v-if="_cancellableTimeSetting == 'ForDayCountAfterPurchase'">
                <b-input-group size="sm">
                  <b-input type="number" min="8" v-model="cancelableDateCount"></b-input>
                </b-input-group>
              </b-col>
              <b-col md="auto" class="ml-2" v-if="_cancellableTimeSetting == 'ForDayCountAfterPurchase'">
                <span>일 취소가능</span>
              </b-col>
            </b-row>
          </b-form-group>

        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>
<script>
// import 'vue-select/dist/vue-select.css'
// import vueSelectSides from "vue-select-sides";
// import "vue-select-sides/styles/themes/light.scss";
import AvailableStore from './AvailableStore.vue';

import api from '../../../../constants/api'
import {
  mapGetters,
  mapActions,
  mapMutations
} from "vuex";

export default {
  components: {
    // vueSelectSides,
    AvailableStore
  },
  mounted() {
    // this.loadStore()
  },
  watch: {

    _expirationDateSetting() {
      // this.goodsShowInfo({currentUser: this.currentUser, siteName: this.siteName})
    },
    _validDayCount() {
      // this.goodsShowInfo({currentUser: this.currentUser, siteName: this.siteName})
    },
    _validFromDate() {
      // this.goodsShowInfo({currentUser: this.currentUser, siteName: this.siteName})
    },
    _validToDate() {
      // this.goodsShowInfo({currentUser: this.currentUser, siteName: this.siteName})
    },

    _cancellableTimeSetting() {
      // this.goodsShowInfo({currentUser: this.currentUser, siteName: this.siteName})
    },

    _cancellableTimeValue() {
    },


    cancelableDateCount() {
      this._cancellableTimeValue = this.cancelableDateCount
      // this.goodsShowInfo({currentUser: this.currentUser, siteName: this.siteName})
    }

  },
  data() {
    return {
      // order: "asc",
      // showTotal: true,
      // leftPlaceholder: "매장명 검색...",
      // rightPlaceholder: "매장명 검색...",
      usableDayOfWeek: "everyday",
      availablePeriod: "hasAvailableDateCount",
      availableDateCount: null,
      availableStartDate: null,
      availableEndDate: null,
      cancelableDateCount: null,
      selected: [],
      // storeList: []
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName', 'goodsType', 'hasSalesPeriod', 'saleEndDate', 'saleStartDate', 'expirationDateSetting'
      , 'validDayCount', 'validFromDate', 'validToDate', 'cancellableTimeSetting', 'cancellableTimeValue'
      , 'storeCodes']),

    _hasSalesPeriod: {
      get: function() {
        return this.hasSalesPeriod
      }, set: function(e) {
        this.setHasSalesPeriod(e)
      }
    },
    _saleStartDate: {
      get: function() {
        return this.saleStartDate
      }, set: function(e) {
        this.setSaleStartDate(e)
      }
    },
    _saleEndDate: {
      get: function() {
        return this.saleEndDate
      }, set: function(e) {
        this.setSaleEndDate(e)
      }
    },
    _expirationDateSetting: {
      get: function() {
        return this.expirationDateSetting
      }, set: function(e) {
        this.setExpirationDateSetting(e)
      }
    },
    _validDayCount: {
      get: function() {
        return this.validDayCount
      }, set: function(e) {
        this.setValidDayCount(e)
      }
    },
    _validFromDate: {
      get: function() {
        return this.validFromDate
      }, set: function(e) {

        this.setValidFromDate(e)
      }
    },
    _validToDate: {
      get: function() {
        return this.validToDate
      }, set: function(e) {
        this.setValidToDate(e)
      }
    },
    _cancellableTimeSetting: {
      get: function() {
        if(this._cancellableTimeValue == 0) {
          return "ForDayCountAfterPurchase0"
        } else if(this._cancellableTimeValue == 7) {
          return "ForDayCountAfterPurchase7"
        } else if(this._cancellableTimeValue == 90) {
          return "ForDayCountAfterPurchase90"
        } else {
          return "ForDayCountAfterPurchase"
        }

      }, set: function(e) {
        if(e === "ForDayCountAfterPurchase0") {
          this._cancellableTimeValue = 0
        } else if(e === "ForDayCountAfterPurchase7") {
          this._cancellableTimeValue = 7
        } else if(e === "ForDayCountAfterPurchase90") {
          this._cancellableTimeValue = 90
        } else {
          this._cancellableTimeValue = this.cancelableDateCount
        }
        this.setCancellableTimeSetting(e)
      }
    },

    _cancellableTimeValue: {
      get: function() {
        if(this.cancellableTimeValue !== null) {
          if(this.cancellableTimeValue != 7 && this.cancellableTimeValue != 90) {
            this.cancelableDateCount = this.cancellableTimeValue
          }
        }
        return this.cancellableTimeValue
      }, set: function(e) {
        if(this.cancellableTimeValue != 7 && this.cancellableTimeValue != 90) {
          this.cancellableTimeValue = this.cancelableDateCount
        }
        this.setCancellableTimeValue(e)
      }
    },
    _storeCodes: {
      get: function() {
        return this.storeCodes
      }, set: function(e) {
        this.setStoreCodes(e)
      }
    }

  },
  methods: {
    ...mapMutations(['setHasSalesPeriod', 'setSaleStartDate', 'setSaleEndDate', 'setExpirationDateSetting',
      'setValidDayCount', 'setValidFromDate', 'setValidToDate', 'setCancellableTimeSetting',
      'setCancellableTimeSettingOption', 'setCancellableTimeValue', 'setStoreCodes']),
    // ...mapActions(['goodsShowInfo']),


  }
}
</script>

